import { Component, input } from '@angular/core';

import { PositionDetailsDialogComponent } from '@core/tellent-positions-smart-ui';
import { InputSignalLike, TellentWebComponent } from '@core/tellent-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-position-details-dialog',
  template: ``,
  imports: [],
})
export class TellentPositionDetailsDialogWrapComponent extends DialogWrapComponent<PositionDetailsDialogComponent> {
  public readonly component = PositionDetailsDialogComponent;
  public readonly config = { width: DialogWidth.Medium };

  public positionGuid: InputSignalLike<string> = input('');

  public override resolveDialogData() {
    return Promise.resolve({ positionGuid: this.positionGuid() });
  }
}

export type TellentPositionDetailsDialogWebComponent = TellentWebComponent<
  TellentPositionDetailsDialogWrapComponent,
  'open' | 'positionGuid' | 'afterClosed'
>;
